















































































































import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer } from '@/api/installServer';
import ChoosePersonDialog from '@/views/inventoryManagement/unit/choosePersonDialog.vue';
import ChooseDeptOrPersonDialog from '@/views/inventoryManagement/unit/chooseDeptOrPersonDialog.vue';
import ChooseAuditDeptDialog from '@/views/inventoryManagement/unit/chooseAuditDeptDialog.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数

@Component({
  components: { ChooseAuditDeptDialog, ChooseDeptOrPersonDialog, ChoosePersonDialog, CollapseTransition },
  mixins: [TableStripe],
})
export default class BatchDialogData extends Vue {
  private visible = false;
  private activeName: any = '';
  private tabPaneArr: any = [];

  private mainTaskIndex: any = -1;
  private childIndex: any = -1;

  fileList: any = [];
  isLoading: any = false; // 点击确定之后

  deptAuditDeptObj: any = {}; // 主任务审核部门/人存储部门选中值
  postAuditDeptObj: any = []; // 主任务审核部门/人存储岗位选中值
  personAuditDeptObj: any = {}; // 主任务审核部门/人存储人员选中值

  headers: any = {};
  actionUrl: any = '';

  // 执行部门
  subSpaceByAuthOptions: any = [];
  // 职务
  spacePostByAuthOptions: any = [];

  formData: any = {
    name: '',
    type: '',
    frequency: '',
    frequencyUnit: '',
    checkDepartment: '',
    remark: '',
    annex: '',
    checkDepartmentId: '',
    checkDepartmentName: '',
    checkStaffIds: '',
    childTaskList: [],
    finishWay: '同步完成',
    taskNature: '固定',
  };

  private async showDialog(data: any) {
    performanceServer.batchCreateDutyRuleData(data).then((res: any) => {
      if (res.code === '200') {
        const arr: any = [];
        res.data.forEach((item: any) => {
          arr.push({
            ...item,
            checkDepartmentId: '',
            checkDepartmentName: '',
            checkStaffIds: '',
            checkStaffIdName: '',
            finishWay: '同步完成',
            annex: '',
            childTaskList: [],
            isShowChildTask: false,
          });
        });
        arr.forEach((item: any) => {
          item.subTaskTimeScopeList.forEach((elem: any) => {
            item.childTaskList.push({
              name: item.dutyContent,
              time: elem,
              executeStaffId: item.executeStaffId,
              executeStaffName: item.executeStaffName,
              checkDeptId: '',
              checkStaffIds: '',
              checkPerson: '',
            });
          });
        });
        this.activeName = res.data[0].dutyListId;
        this.mainTaskIndex = 0;
        this.tabPaneArr = arr;
        console.log(this.tabPaneArr, 'this.tabPaneArr');
      }
    });

    this.fileList = [];
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.visible = true;
  }
  handleClick(e: any) {
    this.mainTaskIndex = e.index;
  }

  addChildTaskList(data: any) {
    this.tabPaneArr[this.mainTaskIndex].childTaskList.push({
      name: data.dutyContent,
      executeStaffId: data.executeStaffId,
      executeStaffName: data.executeStaffName,
      checkStaffIds: '',
      checkDeptId: '',
      checkPerson: '',
      time: this.tabPaneArr[this.mainTaskIndex].childTaskList[0] ? this.tabPaneArr[this.mainTaskIndex].childTaskList[0].time : '',
    });
  }

  deleteChildTaskList(index: any, rowIndex: any) {
    this.tabPaneArr[index].childTaskList.splice(rowIndex, 1);
  }

  // 选择主任务审核部门/人
  chooseAuditDeptLiable() {
    const chooseAuditDeptDialog = 'ChooseAuditDeptDialog';
    const chooseAuditDeptDialogComponent = this.$refs[chooseAuditDeptDialog];
    (chooseAuditDeptDialogComponent as any).showDialog({}, {}, {}); // 传给弹窗的数据
  }
  /**
   * @desc 主任务审核部门/人弹窗中所选的数据
   * */
  getAuditDeptData(deptData: any, postData: any, personData: any) {
    this.deptAuditDeptObj = deptData;
    this.postAuditDeptObj = postData;
    this.personAuditDeptObj = personData;
    if (deptData.id && !personData.id) {
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentId = deptData.id;
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentName = deptData.name;
      this.tabPaneArr[this.mainTaskIndex].checkStaffIds = '';
      this.tabPaneArr[this.mainTaskIndex].checkStaffIdName = deptData.name;
    }
    if (deptData.id && personData.id) {
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentId = deptData.id;
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentName = deptData.name;
      this.tabPaneArr[this.mainTaskIndex].checkStaffIds = personData.id;
      this.tabPaneArr[this.mainTaskIndex].checkStaffIdName = personData.name;
    }
    if (!deptData.id && !personData.id) {
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentId = '';
      this.tabPaneArr[this.mainTaskIndex].checkDepartmentName = '';
      this.tabPaneArr[this.mainTaskIndex].checkStaffIds = '';
      this.tabPaneArr[this.mainTaskIndex].checkStaffIdName = '';
    }
    this.$forceUpdate();
  }

  /**
   * @desc 选择子任务执行人打开弹框
   * */
  choosePersonLiable(data: any, index: any) {
    this.childIndex = index;
    const safetyDialog = 'choosePersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog({}, {}, {}); // 传给弹窗的数据
  }
  /**
   * @desc 主任务 审核人
   * */
  getPersonData(deptData: any, postData: any, personData: any) {
    this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].executeStaffId = personData.id;
    this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].executeStaffName = personData.name;
    this.$forceUpdate();
  }

  /**
   * @desc 选择子任务审核人或审核部门打开弹框
   * */
  chooseDeptOrPersonLiable(data: any, index: any) {
    this.childIndex = index;
    const safetyDialog = 'chooseDeptOrPersonDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog({}, {}, {}); // 传给弹窗的数据
  }
  /**
   * @desc 选择子任务审核人或审核部门触发回调
   * */
  getDeptOrPersonData(deptData: any, postData: any, personData: any) {
    if (deptData.id && personData.id) {
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkDeptId = deptData.id;
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkStaffIds = personData.id;
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkPerson = personData.name;
    }
    if (deptData.id && !personData.id) {
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkDeptId = deptData.id;
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkStaffIds = '';
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkPerson = deptData.name;
    }
    if (!deptData.id && !personData.id) {
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkDeptId = '';
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkStaffIds = '';
      this.tabPaneArr[this.mainTaskIndex].childTaskList[this.childIndex].checkPerson = '';
    }
    this.$forceUpdate();
  }

  itemShowSubTask(data: any) {
    console.log(data, 'sfsf');
    data.isShowChildTask = !data.isShowChildTask;
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.fileList = [];
    this.visible = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const arrObj: any = this.tabPaneArr.map((item: any) => {
      return {
        annex: item.annex,
        checkDepartmentId: item.checkDepartmentId,
        checkDepartmentName: item.checkDepartmentName,
        checkStaffIds: item.checkStaffIds,
        childTaskList: item.childTaskList.map((elem: any) => {
          return {
            startTime: elem.time && elem.time.length ? elem.time[0] : '',
            endTime: elem.time && elem.time.length ? elem.time[1] : '',
            executeStaffId: elem.executeStaffId,
            checkDeptId: elem.checkDeptId,
            checkStaffIds: elem.checkStaffIds,
          };
        }),
        dutyListId: item.dutyListId,
        finishWay: item.finishWay,
      };
    });
    performanceServer.batchCreateDutyRuleCreateData(arrObj).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('添加成功！');
        this.returnDialog();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    if (file.response.data) {
      const arr: any = [];
      fileList.forEach((item: any) => {
        if (item.response) {
          arr.push(item.response.data[0].id);
        } else {
          arr.push(item.name);
        }
      });
      this.tabPaneArr[this.mainTaskIndex].annex = arr.toString();
    } else {
    }
  }
  private handleRemove(file: any, fileList: any) {
    const newArr: any = this.formData.annex.split(',');
    newArr.forEach((item: any, index: any) => {
      if (file.response) {
        if (item === file.response.data[0].id) {
          newArr.splice(index, 1);
        }
      } else {
        newArr.splice(index, 1);
      }
    });
    this.tabPaneArr[this.mainTaskIndex].annex = newArr.toString();
  }
}
